import RequestAbstract from "../abstract";

export default class PublicGatewaySettings extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-gateway-settings";
    }

    async assign(data) {
        // data { id, code, settingsJson }
        return await this.post(`${this.link}/assign`, data);
    }

}
